import React, { useImperativeHandle, useState } from "react";
import { Popup, Position, ToolbarItem } from 'devextreme-react/popup';
import { useScreenSize } from "../../utils/media-query";
import DocumentAttachmentViewer from "../documentAttachmentViewer/documentAttachmentViewer";
import PagamentiViewer from "../pagamentiViewer/pagamentiViewer";

// pdfjs.GlobalWorkerOptions.workerPort = new Worker(
//   'node_modules/pdfjs-dist/build/pdf.worker.entry.js',
// );

type Props = {}

export type PopupShowPagamentoAttachmentHandle = {
    show: (idFiliera: number, idCiclo: number, idDocumento: number) => void,
}

type state = {
    idFiliera: number | undefined,
    idCiclo: number | undefined,
    idPagamento: number | undefined,
    visible: boolean
}

const PopupShowPagamentoAttachment: React.ForwardRefRenderFunction<PopupShowPagamentoAttachmentHandle, Props> = (props, ref) => {
    const [state, setState] = useState<state>({ idFiliera: undefined, idCiclo: undefined, idPagamento: undefined, visible: false });
    const { isXSmall, isSmall } = useScreenSize();

    function hideInfo() {
        setState({ idFiliera: undefined, idCiclo: undefined, idPagamento: undefined, visible: false });
    }

    useImperativeHandle(ref, () => ({
        async show(idFiliera, idCiclo, idDocumento) {

            setState({
                idCiclo: idCiclo,
                idPagamento: idDocumento,
                idFiliera: idFiliera,
                visible: true
            });
        }
    }));


    return (<React.Fragment>
        <Popup
            visible={state.visible}
            dragEnabled={false}
            hideOnOutsideClick={true}
            showCloseButton={false}
            showTitle={true}
            fullScreen={isXSmall || isSmall}
            onHidden={hideInfo}
            title="Visualizza allegato al pagamento"
            container=".dx-viewport"
        >
            <Position
                at="center"
                my="center"
                of=""
                collision="fit"
            />
            <ToolbarItem
                widget="dxButton"
                toolbar="bottom"
                location="center"
                options={{
                    text: 'Chiudi',
                    onClick: hideInfo,
                }}
            />

            {state.visible &&
                <PagamentiViewer idFiliera={state.idFiliera} idCiclo={state.idCiclo} idPagamento={state.idPagamento} />
            }
        </Popup>
    </React.Fragment>
    );
}

export default React.forwardRef(PopupShowPagamentoAttachment);
